import api from "./api";

async function clicklifeAuth(): Promise<void> {
  try {
    await api.post("/api/v2/app/telemedicina-clicklife/auth");
  } catch (error: any) {
    return Promise.reject({
      ...error,
      message:
        error?.message ||
        "Um erro inesperado aconteceu ao tentar autenticar no serviço de telemedicina. Entre em contato com o suporte.",
    });
  }
}

type ClicklifeCreateAtendimentoData = {
  attachments?: string[];
  observations?: string;
};

type ClicklifeCreateAtendimentoResponse = {
  url: string;
};

async function clicklifeCreateAtendimento(
  createAtendimentoData: ClicklifeCreateAtendimentoData
): Promise<ClicklifeCreateAtendimentoResponse> {
  try {
    const data = await api
      .post(
        "/api/v2/app/telemedicina-clicklife/atendimento",
        createAtendimentoData
      )
      .then((response) => response.data);

    return data;
  } catch (error) {
    return Promise.reject({
      ...error,
      message:
        error?.message ||
        "Não foi possível prosseguir com a consulta. Tente novamente. Se o erro persistir, entre em contato com o suporte.",
    });
  }
}

const telemedicinaApi = {
  clicklifeAuth,
  clicklifeCreateAtendimento,
};

export default telemedicinaApi;
